import axios from 'axios'

export default class PaymentRegular {
  constructor(parent, id) {
    this._loading = false;
    this.$parent = parent;
    this._data = {
      id: id ? id : 0,
      name: '',
      operation: 0,
      rateArticle: 0,
      category: 0,
      type: 0,
      cash: 0,
      account: 0,
      accountNumber: '',
      contragentType: 1,
      contragent: '',
      contragentName: '',
      legal: '',
      legalName: '',
      sum: 0,
      debt: 0,
      currency: 1,
      PaymentDetails: [],
      agreements: [],
    };
  }

  add() {
    const self = this;
    return new Promise((resolve, reject) => {
      self
        .get()
        .then(() => {
          self.loading = true;
          if (!self.$parent._items.length) {
            self.$parent.$parent.direction = 1;
            self.$parent.$parent.operation = self._data.operation;
            self.$parent.$parent.rateArticle = self._data.rateArticle;
            self.$parent.$parent.category = self._data.category;
            self.$parent.$parent.type = self._data.type;
            self.$parent.$parent.cash = self._data.cash;
            self.$parent.$parent.account = self._data.account;
            self.$parent.$parent.contragentType = self._data.contragentType;
            self.$parent.$parent.contragent = self._data.contragent;
            self.$parent.$parent.contragentName = self._data.contragentName;
            self.$parent.$parent.legal = self._data.legal;
            self.$parent.$parent.legalName = self._data.legalName;
            self.$parent.$parent.currency = self._data.currency;
          }
          Promise
            .all(self._data.PaymentDetails.map(i => self.$parent.agreement.regular(i)))
            .then(() => {
              resolve(self)
            }, reject)
            .finally(() => {
              self.loading = false;
            })
        }, reject)
    });
  }

  get() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      axios
        .all([
          axios({
            method: 'get',
            url: `/tourclient/payment/regular/${self.id}?_ZZZ=${new Date().getTime()}`,
            // requestId: 'payment/regular/' + self.id,
          }),
          axios({
            method: 'get',
            url: `/tourclient/payment/payInfo/${self.id}?_ZZZ=${new Date().getTime()}`,
            // requestId: 'payment/payInfo/' + self.id,
          })
        ])
        .then(arr => {
          const regular = arr[0].data.Item;
          const info = arr[1].data;
          const type = self.$parent.dictionary.types.find(i => i.id === regular.PaymentTypeId);
          self._data.name = regular.Name;
          self._data.operation = regular.PaymentOperationID;
          self._data.rateArticle = regular.RateArticleId;
          self._data.category = type ? type.category : 0;
          self._data.type = regular.PaymentTypeId;
          self._data.cash = regular.CashId;
          self._data.account = regular.PaymentAccountId;
          self._data.accountNumber = regular.AccountNumber;
          self._data.contragentType = regular.ContragentType;
          self._data.contragent = regular.ContragentID;
          self._data.contragentName = regular.ContragentName;
          self._data.legal = regular.PartnerLegalEntityId ? regular.PartnerLegalEntityId : '';
          self._data.legalName = regular.PartnerLegalName ? regular.PartnerLegalName : '';
          self._data.sum = info.PaymentSum;
          self._data.debt = info.PaymentSum;
          self._data.currency = regular.CurrencyId;
          self._data.PaymentDetails = regular.PaymentDetails;
          self._data.agreements = regular.PaymentDetails ? regular.PaymentDetails.map(i => ({
            code: i.Code,
            requests: i.OrderPrices.filter(j => j.Spread).map(j => ({
              id: j.RequestId,
              value: j.Spread,
            })),

          })) : [];
          resolve(self)
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => {
          self.loading = false;
        });
    });
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get id() {
    return this._data.id;
  }

  set id(value) {
    this._data.id = value;
  }

  get value() {
    return this._data.id;
  }

  get label() {
    return this._data.name;
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
  }

  get agreements() {
    return this._data.agreements;
  }

  get sum() {
    return this._data.sum;
  }

  set sum(value) {
    this._data.sum = value;
  }

  get debt() {
    return this._data.debt;
  }

}